// WarningRibbon.jsx - Compact Style
import React, { useState, useEffect } from "react";
import { 
  DollarSign, 
  Clock, 
  AlertTriangle,
  X,
  ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASEURL } from "../constants";

const WarningRibbon = () => {
  const [alerts, setAlerts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  const studentId = localStorage.getItem("studentId");

  useEffect(() => {
    const fetchAlerts = async () => {
      if (!studentId) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${BASEURL}Student/alerts/${studentId}`);
        setAlerts(response.data);
      } catch (err) {
        console.error("Error fetching alerts:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAlerts();
  }, [studentId]);

  if (isLoading || isDismissed || !alerts) return null;

  const fa = alerts?.financialAlert;
  const aa = alerts?.attendanceAlert;
  const hideTimetableAndAttendance = Boolean(window.configs?.hideTimetableAndAttendance);

  const hasFinancialIssue = fa?.alertSeverity !== "Info";
  const hasAttendanceIssue = !hideTimetableAndAttendance && aa?.alertSeverity !== "Info";

  if (!hasFinancialIssue && !hasAttendanceIssue) return null;

  const isCritical = fa?.alertSeverity === "Critical" || (hasAttendanceIssue && aa?.alertSeverity === "Critical");

  return (
    <div className={`
      bg-white rounded-xl border shadow-sm overflow-hidden
      ${isCritical ? "border-red-200" : "border-amber-200"}
    `}>

      
      <div className="p-4">
        <div className="flex items-center justify-between gap-4">
          {/* Left section */}
          <div className="flex items-center gap-4 flex-1 min-w-0">
            {/* Alert Icon */}
            <div className={`
              w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
              ${isCritical ? "bg-red-100" : "bg-amber-100"}
            `}>
              <AlertTriangle className={`w-5 h-5 ${isCritical ? "text-red-600" : "text-amber-600"}`} />
            </div>

            {/* Alert Items */}
            <div className="flex items-center gap-6 flex-wrap">
              {/* Financial */}
              {hasFinancialIssue && (
                <div className="flex items-center gap-3">
                  <div className={`
                    w-8 h-8 rounded-lg flex items-center justify-center
                    ${fa?.alertSeverity === "Critical" ? "bg-red-50" : "bg-amber-50"}
                  `}>
                    <DollarSign className={`w-4 h-4 ${
                      fa?.alertSeverity === "Critical" ? "text-red-600" : "text-amber-600"
                    }`} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900">{fa?.overdueAmount}</p>
                    <p className="text-xs text-gray-500">{fa?.daysOverdue} days overdue</p>
                  </div>
                </div>
              )}

              {/* Divider */}
              {hasFinancialIssue && hasAttendanceIssue && (
                <div className="h-8 w-px bg-gray-200 hidden sm:block" />
              )}

              {/* Attendance */}
              {hasAttendanceIssue && (
                <div className="flex items-center gap-3">
                  <div className={`
                    w-8 h-8 rounded-lg flex items-center justify-center
                    ${aa?.alertSeverity === "Critical" ? "bg-red-50" : "bg-amber-50"}
                  `}>
                    <Clock className={`w-4 h-4 ${
                      aa?.alertSeverity === "Critical" ? "text-red-600" : "text-amber-600"
                    }`} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900">{aa?.currentAttendance}% Attendance</p>
                    <p className="text-xs text-gray-500">Required: {80}%</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right section */}
          {/* <div className="flex items-center gap-2 flex-shrink-0">
            <Link
              to="/dashboard/make-a-request"
              className={`
                hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-colors
                ${isCritical 
                  ? "bg-red-600 hover:bg-red-700 text-white" 
                  : "bg-amber-500 hover:bg-amber-600 text-white"
                }
              `}
            >
              Take Action
              <ArrowRight className="w-4 h-4" />
            </Link>

            <button
              onClick={() => setIsDismissed(true)}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WarningRibbon;